var indentation_default = {
  "indentZero": "YjabP",
  "indentOne": "kI5d6",
  "indentTwo": "udsw0",
  "indentThree": "YDLsn",
  "indentFour": "LtE3Y",
  "indentFive": "b-vJV",
  "indentSix": "c-D5E"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
